// src/components/ui/calendar/day/DayViewTimeRow/DayViewTimeRowShadcn.jsx
import React from 'react';
import { cn } from '../../../../../utils/cn';
import { CalendarHourLabelShadcn } from '../../core';

const DayViewTimeRowShadcn = ({
  hour,
  currentDate,
  events = [],
  onTimeSlotClick,
  isAdmin = false,
  children, // For custom content or events
  // NEW: Availability props
  hasAvailability = false,         // ← ADD THIS
  viewingPartnerAvailability = false, // ← ADD THIS
  className = ''
}) => {
  const handleSlotClick = () => {
    if (isAdmin && onTimeSlotClick) {
      onTimeSlotClick(currentDate, hour);
    }
  };

  return (
    <div className={cn(
      "flex border-b border-slate-600/20 h-16",
      className
    )}>
      {/* Hour label */}
      <CalendarHourLabelShadcn hour={hour} />

      {/* Hour content with side-by-side events */}
      <div
        className={cn(
          "flex-1 relative h-16 group",
          "transition-colors duration-200",
          isAdmin && "cursor-pointer",

          // NEW: Purple availability styling
          hasAvailability && "bg-purple-600/10 border-l-2 border-purple-500/30",
          hasAvailability && "hover:bg-purple-600/20",

          // Original hover (but skip if has availability)
          !hasAvailability && "hover:bg-slate-700/10"
        )}
        onClick={handleSlotClick}
      >
        {/* NEW: Availability indicator */}
        {hasAvailability && (
          <div className="absolute top-1 right-1 w-1.5 h-1.5 bg-purple-400 rounded-full"></div>
        )}

        {/* Custom content or events */}
        {children}
      </div>
    </div>
  );
};

export default DayViewTimeRowShadcn;